module.exports = __webpack_public_path__ + "static/img/feature-2.34ebec6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature-2.png
// module id = 3ncs
// module chunks = 1